import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import {
  Container,
  Row,
  Col
} from 'reactstrap';
import Select from '../../shared/Select';
import CountryDropdown from '../../shared/CountryDropdown';
import StateDropdown from '../../shared/StateDropdown';
import SubscriptionDropdown from '../../shared/SubscriptionDropdown';
import CompanyStatusDropdown from '../../shared/CompanyStatusDropdown';
import LabeledInput from '../../shared/LabeledTextInput';
import InfoField from '../../shared/InfoField';
import {
  validatePhone,
  validateEmail,
  isNaturalNumber,
  validateUrl
} from '../../../utils/validators';


const propTypes = {
  isSpruceAdmin: PropTypes.bool,
  edit: PropTypes.bool,
  editStatus: PropTypes.bool,
  editSubscription: PropTypes.bool,
  editCustomerNumber: PropTypes.bool,
  company: PropTypes.object,
  errors: PropTypes.object,
  showErrors: PropTypes.bool,
  onFieldChange: PropTypes.func,
  onFieldValidate: PropTypes.func
};

const defaultProps = {
  company: {}
};

export class CompanyInfo extends React.PureComponent {
  constructor(props) {
    super(props);
  }

  render () {
    const {
      isSpruceAdmin,
      edit,
      editStatus,
      editSubscription,
      editCustomerNumber,
      company,
      errors,
      showErrors,
      onFieldChange,
      onFieldValidate,
    } = this.props;
    const status = company.enabled ? 'Active' : 'Inactive';

    return (
      <Container fluid className='px-0 text-left'>
        <Row>
          <Col md={6} className='mb-3'>
            <InfoField
              editMode={editStatus}
              label={`Status ${editStatus ? '*' : ''}`}
              value={status}>
              <CompanyStatusDropdown
                value={status}
                onChange={(value) => onFieldChange('enabled', !!(value === 'Active'))}
              />
            </InfoField>
          </Col>
          <Col md={6} className='mb-3'>
            <InfoField
              editMode={editSubscription}
              label={`Subscription ${editSubscription ? '*' : ''}`}
              value={company.subscription}>
              <SubscriptionDropdown
                value={company.subscription}
                onChange={(value) => onFieldChange('subscription', value)}
              />
            </InfoField>
          </Col>
        </Row>
        <Row>
          <Col className='mb-3'>
            <LabeledInput
              editMode={edit}
              label={`Company Name ${edit ? '*' : ''}`}
              value={company.name}
              error={errors.name}
              invalid={(showErrors || company.name) && errors.name}
              allowBlank={false}
              minLength={1}
              maxLength={100}
              onChange={value => onFieldChange('name', value)}
              onValidate={value => onFieldValidate('name', value)}
            />
          </Col>
        </Row>
        <Row>
          <Col md={6} className='mb-3'>
            <LabeledInput
              editMode={editCustomerNumber}
              label={`Customer Number ${editCustomerNumber ? '*' : ''}`}
              value={company.customerNumber}
              error={errors.customerNumber}
              invalid={(showErrors || company.customerNumber) && errors.customerNumber}
              allowBlank={false}
              minLength={3}
              maxLength={25}
              onChange={value => onFieldChange('customerNumber', value)}
              onValidate={value => onFieldValidate('customerNumber', value)}
            />
          </Col>
          <Col md={6} className='mb-3'>
            <LabeledInput
              editMode={edit}
              label='Email *'
              value={company.email}
              error={errors.email}
              invalid={(showErrors || company.email) && errors.email}
              allowBlank={false}
              validator={validateEmail}
              validationError={'Invalid email format'}
              onChange={value => onFieldChange('email', value)}
              onValidate={value => onFieldValidate('email', value)}
            />
          </Col>
        </Row>
        <Row>
          <Col md={6} className='mb-3'>
            <LabeledInput
              editMode={edit}
              label='Phone'
              value={company.phone}
              error={errors.phone}
              invalid={errors.phone}
              validator={validatePhone}
              validationError={'Invalid phone/fax format'}
              onChange={value => onFieldChange('phone', value)}
              onValidate={value => onFieldValidate('phone', value)}
            />
          </Col>
          <Col md={6} className='mb-3'>
            <LabeledInput
              editMode={edit}
              label='Fax'
              value={company.fax}
              error={errors.fax}
              invalid={errors.fax}
              validator={validatePhone}
              validationError={'Invalid phone/fax format'}
              onChange={value => onFieldChange('fax', value)}
              onValidate={value => onFieldValidate('fax', value)}
            />
          </Col>
        </Row>
        <Row>
          <Col md={6} className='mb-3'>
            <LabeledInput
              editMode={edit}
              label='Address 1'
              value={company.address1}
              error={errors.address1}
              invalid={errors.address1}
              maxLength={100}
              onChange={value => onFieldChange('address1', value)}
              onValidate={value => onFieldValidate('address1', value)}
            />
          </Col>
          <Col md={6} className='mb-3'>
            <LabeledInput
              editMode={edit}
              label='City'
              value={company.city}
              error={errors.city}
              invalid={errors.city}
              maxLength={50}
              onChange={value => onFieldChange('city', value)}
              onValidate={value => onFieldValidate('city', value)}
            />
          </Col>
        </Row>
        <Row>
          <Col md={6} className='mb-3'>
            <LabeledInput
              editMode={edit}
              label='Address 2'
              value={company.address2}
              error={errors.address2}
              invalid={errors.address2}
              maxLength={100}
              onChange={value => onFieldChange('address2', value)}
              onValidate={value => onFieldValidate('address2', value)}
            />
          </Col>
          <Col md={6} className='mb-3'>
            <InfoField
              editMode={edit}
              label='State/Province'
              value={company.state}>
                <StateDropdown
                  country={company.country}
                  value={company.state}
                  onChange={(value) => onFieldChange('state', value)}
                />
            </InfoField>
          </Col>
        </Row>
        <Row>
          <Col md={6} className='mb-3'>
            <LabeledInput
              editMode={edit}
              label='Postal Code'
              value={company.postalCode}
              error={errors.postalCode}
              invalid={errors.postalCode}
              minLength={2}
              maxLength={12}
              onChange={value => onFieldChange('postalCode', value)}
              onValidate={value => onFieldValidate('postalCode', value)}
            />
          </Col>
          <Col md={6} className='mb-3'>
            <InfoField
              editMode={edit}
              label={`Country ${edit ? '*' : ''}`}
              value={company.coutry}>
              <CountryDropdown
                value={company.country}
                onChange={(value) => onFieldChange('country', value)}
              />
            </InfoField>
          </Col>
        </Row>
        <Row>
          <Col md={6} className='mb-3'>
            <LabeledInput
              editMode={edit}
              label='County'
              value={company.county}
              error={errors.county}
              invalid={errors.county}
              maxLength={100}
              onChange={value => onFieldChange('county', value)}
              onValidate={value => onFieldValidate('county', value)}
            />
          </Col>
          <Col md={6} className='mb-3'>
            <LabeledInput
              editMode={edit}
              label='Website'
              value={company.companyUrl}
              error={errors.companyUrl}
              invalid={errors.companyUrl}
              maxLength={100}
              validator={validateUrl}
              validationError={'The website field is not a valid URL'}
              onChange={value => onFieldChange('companyUrl', value)}
              onValidate={value => onFieldValidate('companyUrl', value)}
            />
          </Col>
        </Row>
        <If condition={isSpruceAdmin}>
          <Row>
            <Col md={6} className='mb-3'>
              <InfoField
                editMode={true}
                label='Rental Customer'
              >
                <Select
                  value={company.rentalCustomer ? 'Yes' : 'No'}
                  onChange={value => onFieldChange('rentalCustomer', (value === 'Yes'))}
                  options={['Yes', 'No']}
                />
              </InfoField>
            </Col>
            <Col md={6} className='mb-3'>
              <LabeledInput
                type='number'
                editMode={edit}
                label='Rental Units *'
                value={company.rentalUnits}
                allowBlank={false}
                blankValidator={value => value >= 0}
                error={errors.rentalUnits}
                invalid={(showErrors || company.rentalUnits) && errors.rentalUnits}
                validator={isNaturalNumber}
                validationError={'Field value should be a positive integer'}
                onChange={value => onFieldChange('rentalUnits', value)}
                onValidate={value => onFieldValidate('rentalUnits', value)}
              />
            </Col>
          </Row>
          <Row>
            <Col md={6} className='mb-3'>
              <LabeledInput
                type='number'
                editMode={edit}
                label='Purchased Units *'
                value={company.purchasedUnits}
                allowBlank={false}
                blankValidator={value => value >= 0}
                error={errors.purchasedUnits}
                invalid={(showErrors || company.purchasedUnits) && errors.purchasedUnits}
                validator={isNaturalNumber}
                validationError={'Field value should be a positive integer'}
                onChange={value => onFieldChange('purchasedUnits', value)}
                onValidate={value => onFieldValidate('purchasedUnits', value)}
              />
            </Col>
          </Row>
        </If>
      </Container>
    );
  }
}

CompanyInfo.propTypes = propTypes;
CompanyInfo.defaultProps = defaultProps;

const mapStateToProps = ({ profile }) => ({
  isSpruceAdmin: profile.isSpruceAdmin
});

export default connect(mapStateToProps)(CompanyInfo);


// WEBPACK FOOTER //
// src/components/companyDetails/CompanyInfo/index.jsx